const demoProdHost = 'demo-iframe.gr8.tech';
const demoStageHost = 'iframe-holder-fe.stage.gr8.tech';
const beterProdHost = 'iframe-test1.online';
const newBeterProdHost = 'iframe.beter.co';
const demoBrandProdHost = 'sport-iframe.sdfojsd.com';
const iframeEuHost = 'gr8-iframe-eu.com';
const iframeAsiaHost = 'gr8-iframe-asia.com';
const iframeLatamHost = 'gr8-iframe-latam.com';
const iframeIndiaHost = 'gr8-iframe-india.com';
const iframeTurkeyHost = 'gr8-iframe-turkey.com';
const iframeCrmHost = 'iframe-crm-fe.stage.gr8.tech';
const config = new Map();

const iframeTargetsByMode = {
  betbook: 'https://betbook.localhost:8080',
  fastbook: 'https://gr8sport-demodflt.stage.localhost:3000',
  http: 'localhost:8080',
};
config.set(
  'localhost:4000',
  iframeTargetsByMode[process.env.REACT_APP_IFRAME_TARGET] || iframeTargetsByMode.http,
);
config.set(demoStageHost, 'gr8sport-demodflt-fastbook.stage.gr8.tech');
config.set(
  'iframe-crm-fe.stage.gr8.tech',
  'zoo-zebra.stage.gr8.tech',
);

config.set(demoProdHost, demoBrandProdHost);
config.set(iframeEuHost, 'gr8sport-demodflt-fastbook.stage.gr8.tech');
config.set(iframeAsiaHost, 'sport-iframe.gr8-iframe-asia.com');
config.set(iframeLatamHost, 'sport-iframe.gr8-iframe-latam.com');
config.set(iframeIndiaHost, 'sport-iframe.apccje.xyz');
config.set(iframeTurkeyHost, 'sport-iframe.vnyuw.xyz');
config.set(iframeCrmHost, 'zoo-zebra.stage.gr8.tech');
config.set(beterProdHost, 'sport-iframe.iframe-test1.online');
config.set(newBeterProdHost, 'esport-iframe.beter.co');
config.set('iframe-test.online', 'sport-iframe.iframe-test.online');

const host = window.location.host;

export const isBetterHost = host === beterProdHost || host === newBeterProdHost;

export const isBeterEsportHost = host === beterProdHost;

export const isIframeEuHost = host === iframeEuHost;
export const isIframeAsiaHost = host === iframeAsiaHost;
export const isIframeLatamHost = host === iframeLatamHost;
export const DEFAULT_DEMO_HOST = 'https://gr8sport-demodflt-fastbook.stage.gr8.tech/';
export const isIframeIndiaHost = host === iframeIndiaHost;
export const isIframeTurkeyHost = host === iframeTurkeyHost;
export const isIframeCrmHost = host === iframeCrmHost;
export const isDemoHost = [demoProdHost, demoStageHost, iframeEuHost, 'localhost:4000'].includes(host);

export default config;